import { PcApiResponse } from '@/api/pc-api/types';
import { StatType } from '@/api/pc-api/v1/{authInfoId}/service-stat/type';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

type Args = {
  statType: StatType;
  statDate: string;
};

export type RequestRankingSummary =
  | {
      companyName: string;
      requestCount: number;
      totalRequestCount: number;
      ratio: number;
    }
  | undefined;

export const getRequestRankingSummary = (args: Args) => {
  return api<PcApiResponse<RequestRankingSummary>>(
    'get',
    `/pc-api/v1/${PREFIX_PATH}/service-stat/request-ranking-summary`,
    args
  );
};
